/* global BX, FormUtils */

(function () {
    if (typeof BX === 'undefined' || typeof FormUtils === 'undefined') return;

    const form = document.getElementById('catalog-detail__question');
    const submitBtn = document.getElementById('submit-feedback-btn');
    const commonErrorsBlock = document.getElementById('question-form-common-errors');
    const captchaContainerId = 'captcha-container-question';
    const containerSelector = '';

    const fullname = document.getElementById('fullname-question');
    const phone = document.getElementById('phone-question');
    const email = document.getElementById('email-question');
    const message = document.getElementById('message-question');
    const productName = document.getElementById('productName');

    if (!form || !submitBtn) return;

    FormUtils.setupPhoneMask(phone);
    FormUtils.initCaptcha(captchaContainerId);

    const hideErrors = () => {
        FormUtils.clearFieldErrors(containerSelector);
        FormUtils.hideCommonError(commonErrorsBlock);
    };

    const validate = () => {
        let isValid = true;
        hideErrors();

        if (!FormUtils.validateRequired(fullname.value)) {
            FormUtils.showFieldError(fullname, '*Обязательное поле');
            isValid = false;
        }

        const phoneDigits = phone.value.replace(/\D/g, '');
        if (!FormUtils.validateRequired(phone.value)) {
            FormUtils.showFieldError(phone, '*Обязательное поле');
            isValid = false;
        } else if (!FormUtils.validatePhoneDigits(phoneDigits)) {
            FormUtils.showFieldError(phone, '*Введите корректный номер телефона (не менее 10 цифр)');
            isValid = false;
        }

        if (FormUtils.validateRequired(email.value)) {
            if (!FormUtils.validateEmail(email.value)) {
                FormUtils.showFieldError(email, '*Введите корректный E-mail');
                isValid = false;
            }
        }

        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        if (!captchaToken || !captchaToken.value) {
            FormUtils.showCommonError(commonErrorsBlock, 'Пожалуйста, подтвердите, что вы не робот');
            isValid = false;
        }

        if (!isValid) FormUtils.scrollToFirstError(containerSelector, commonErrorsBlock);
        return isValid;
    };

    const send = async () => {
        if (!validate()) return;

        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        const payload = {
            fullname: fullname.value,
            phone: phone.value,
            email: email.value,
            message: message.value,
            smart_token: captchaToken ? captchaToken.value : '',
            productUrl: window.location.href,
            productName: productName.value,
        };

        await FormUtils.sendFormData({
            url: '/api/v1/form/ask-question',
            payload,
            submitBtn,
            commonErrorsBlock,
            containerSelector,
            onSuccess: (result) => {
                alert(result.message || 'Спасибо! Ваше сообщение отправлено.');
                close();
            },
            onFieldError: (field, msg) => {
                const el = document.getElementById(field);
                if (el) FormUtils.showFieldError(el, msg);
            },
        });
    };

    submitBtn.addEventListener('click', send);
})();
